import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

// Fetch specific item from specific collection
export const fetchFromFirebase = async (collection, id) => {
    const db = firebase.firestore();
    const docRef = db.collection(collection).doc(id);
    const doc = await docRef.get();
    if (doc.exists) {
      return { id: doc.id, ...doc.data() };
    } else {
      throw new Error(`Document with id '${id}' not found in collection '${collection}'.`);
    }
};

// Fetch Posts
export const fetchPosts = async () => {
  const db = firebase.firestore();
  const snapshot = await db.collection("posts").orderBy("date", "desc").limit(9).get();
  const posts = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  return posts;
};

// Fetch a specific post by id
export const fetchPostById = async (id) => {
  const db = firebase.firestore();
  const snapshot = await db.collection("posts").doc(id).get();
  if (!snapshot.exists) {
    throw new Error(`Post with id ${id} not found`);
  }
  const postData = snapshot.data();
  return { id: snapshot.id, ...postData };
};

// Create Posts
export const createPost = async (newPost) => {
  const db = firebase.firestore();
  const docRef = await db.collection("posts").add(newPost);
  const snapshot = await docRef.get();
  const post = { id: snapshot.id, ...snapshot.data() };
  return post;
};

// Update Post
export const updatePost = async (postId, updatedPost) => {
  const db = firebase.firestore();
  const postRef = db.collection("posts").doc(postId);
  await postRef.update(updatedPost);
  return { id: postId, ...updatedPost };
};

// Delete Posts
export const deletePost = async (postId) => {
  const db = firebase.firestore();
  const storage = firebase.storage();

  const postRef = db.collection("posts").doc(postId);
  const postDoc = await postRef.get();
  const imageUrl = postDoc.data().image;

  // Delete post data from Firestore
  await db.collection("posts").doc(postId).delete();

  // Delete image from Storage
  if (imageUrl) {
    const storageRef = storage.refFromURL(imageUrl);
    await storageRef.delete();
  }
};